export const catalogItems = [
  {
    id: 1,
    title: "星河远征",
    category: "电影",
    genre: "科幻",
    year: 2025,
    region: "中国",
    rating: 8.9,
    poster:
      "https://readdy.ai/api/search-image?query=A%20lone%20astronaut%20silhouette%20standing%20before%20a%20glowing%20distant%20galaxy%2C%20swirling%20nebulae%20and%20scattered%20stars%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-01&orientation=portrait",
    summary: "人类首支深空探险队穿越虫洞，在星海的尽头寻找第二个家园，也重新认识了彼此。",
    meta: "128 分钟",
    tag: "独家上线",
    hot: true,
  },
  {
    id: 2,
    title: "无声告白",
    category: "电影",
    genre: "剧情",
    year: 2024,
    region: "中国",
    rating: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=A%20quiet%20rainy%20city%20street%20with%20a%20single%20figure%20holding%20an%20umbrella%2C%20muted%20warm%20reflections%20on%20wet%20pavement%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-02&orientation=portrait",
    summary: "一场未说出口的告别，让三个普通家庭在同一个雨夜产生了意料之外的交集。",
    meta: "116 分钟",
    tag: "口碑佳作",
  },
  {
    id: 3,
    title: "城市之光",
    category: "电影",
    genre: "犯罪",
    year: 2025,
    region: "中国",
    rating: 8.1,
    poster:
      "https://readdy.ai/api/search-image?query=Neon-lit%20night%20city%20skyline%20with%20a%20detective%20silhouette%20in%20a%20narrow%20alley%2C%20amber%20and%20crimson%20glow%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-03&orientation=portrait",
    summary: "一桩看似普通的失踪案，牵出整座城市光鲜表面下隐藏的交易链条。",
    meta: "134 分钟",
    tag: "正在热映",
    hot: true,
  },
  {
    id: 4,
    title: "追风少年",
    category: "电影",
    genre: "运动",
    year: 2023,
    region: "中国",
    rating: 7.8,
    poster:
      "https://readdy.ai/api/search-image?query=Young%20runner%20sprinting%20on%20a%20dusty%20track%20at%20golden%20sunset%2C%20motion%20blur%20of%20dust%2C%20warm%20golden%20light%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-04&orientation=portrait",
    summary: "小城少年为一场省级比赛拼尽全力，在跑道上找回了被自己放弃很久的梦想。",
    meta: "112 分钟",
    tag: "燃情推荐",
  },
  {
    id: 5,
    title: "深海禁区",
    category: "电影",
    genre: "悬疑",
    year: 2025,
    region: "中国",
    rating: 8.6,
    poster:
      "https://readdy.ai/api/search-image?query=Deep%20ocean%20abyss%20with%20a%20small%20submersible%20and%20faint%20bioluminescent%20glow%2C%20dark%20tones%20with%20warm%20amber%20accents%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-05&orientation=portrait",
    summary: "科考潜水器失联七天后重新浮出水面，带回的却是一段无法解释的影像。",
    meta: "122 分钟",
    tag: "高分悬疑",
    hot: true,
  },
  {
    id: 6,
    title: "山河故人录",
    category: "电影",
    genre: "历史",
    year: 2024,
    region: "中国",
    rating: 8.8,
    poster:
      "https://readdy.ai/api/search-image?query=Ancient%20mountain%20pass%20with%20a%20lone%20traveler%20and%20misty%20peaks%20at%20dawn%2C%20warm%20sepia%20and%20gold%20tones%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-06&orientation=portrait",
    summary: "一封迟到了四十年的家书，串起三代人跨越山川的离散与重逢。",
    meta: "145 分钟",
    tag: "年度口碑",
  },
  {
    id: 7,
    title: "午夜列车",
    category: "电影",
    genre: "惊悚",
    year: 2025,
    region: "韩国",
    rating: 7.6,
    poster:
      "https://readdy.ai/api/search-image?query=A%20mysterious%20vintage%20train%20speeding%20through%20darkness%20with%20glowing%20windows%2C%20tense%20shadows%2C%20amber%20beam%20light%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-07&orientation=portrait",
    summary: "末班列车上乘客逐一消失，唯一的乘客必须在到站前找出真正的同行者。",
    meta: "108 分钟",
    tag: "午夜场",
  },
  {
    id: 8,
    title: "春日食光",
    category: "电影",
    genre: "治愈",
    year: 2024,
    region: "日本",
    rating: 8.2,
    poster:
      "https://readdy.ai/api/search-image?query=Cozy%20sunlit%20kitchen%20table%20with%20fresh%20ingredients%20and%20soft%20steam%2C%20warm%20golden%20tones%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-08&orientation=portrait",
    summary: "一间开在巷子深处的小食堂，用一日三餐慢慢修补每一位客人的心事。",
    meta: "105 分钟",
    tag: "治愈系",
  },
  {
    id: 9,
    title: "长夜长歌",
    category: "电视剧",
    genre: "古装",
    year: 2025,
    region: "中国",
    rating: 9.0,
    poster:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20rooftop%20under%20a%20vast%20starry%20sky%2C%20flowing%20silk%20and%20hanging%20lanterns%2C%20deep%20crimson%20and%20gold%20tones%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-09&orientation=portrait",
    summary: "乱世之中，一位掌印女官以谋略护住家族与城池，唱响一段跨越十年的长歌。",
    meta: "全 40 集",
    tag: "独家热播",
    hot: true,
  },
  {
    id: 10,
    title: "破晓行动",
    category: "电视剧",
    genre: "悬疑",
    year: 2025,
    region: "中国",
    rating: 8.7,
    poster:
      "https://readdy.ai/api/search-image?query=Silhouetted%20special%20agent%20on%20a%20rooftop%20at%20cold%20pre-dawn%2C%20city%20lights%20far%20below%2C%20amber%20and%20charcoal%20tones%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-10&orientation=portrait",
    summary: "专案组在破晓前展开收网，每一个证人都可能是敌人，每一句口供都藏着反转。",
    meta: "全 24 集",
    tag: "更新至 18 集",
    hot: true,
  },
  {
    id: 11,
    title: "我们的十年",
    category: "电视剧",
    genre: "都市",
    year: 2024,
    region: "中国",
    rating: 8.3,
    poster:
      "https://readdy.ai/api/search-image?query=Group%20of%20friends%20laughing%20on%20a%20warm%20sunset%20rooftop%20overlooking%20a%20city%2C%20nostalgic%20golden%20light%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-11&orientation=portrait",
    summary: "五个大学室友毕业后的十年，理想、友情与爱情在现实的打磨中各自生长。",
    meta: "全 36 集",
    tag: "都市情感",
  },
  {
    id: 12,
    title: "医者仁心",
    category: "电视剧",
    genre: "职场",
    year: 2024,
    region: "中国",
    rating: 8.5,
    poster:
      "https://readdy.ai/api/search-image?query=Surgeon%20hands%20in%20warm%20operating%20room%20light%20with%20soft%20focus%20background%2C%20hopeful%20amber%20glow%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-12&orientation=portrait",
    summary: "急诊科的每一次抢救都是与时间赛跑，年轻医生在生与死的边界理解职业的意义。",
    meta: "全 30 集",
    tag: "现实主义",
  },
  {
    id: 13,
    title: "边界线",
    category: "电视剧",
    genre: "谍战",
    year: 2025,
    region: "中国",
    rating: 8.9,
    poster:
      "https://readdy.ai/api/search-image?query=Foggy%20border%20checkpoint%20at%20dusk%20with%20a%20lone%20figure%20in%20a%20long%20coat%2C%20tense%20amber%20lighting%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-13&orientation=portrait",
    summary: "一位潜伏多年的情报员接到最后一项任务，而命令的来源已经无法确认。",
    meta: "全 28 集",
    tag: "高能谍战",
    hot: true,
  },
  {
    id: 14,
    title: "剑与星尘",
    category: "动漫",
    genre: "热血",
    year: 2025,
    region: "日本",
    rating: 9.1,
    poster:
      "https://readdy.ai/api/search-image?query=Anime%20warrior%20holding%20a%20glowing%20sword%20against%20a%20starry%20cosmic%20sky%2C%20dynamic%20energy%2C%20warm%20gold%20and%20red%20sparks%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-14&orientation=portrait",
    summary: "少年剑士为寻找失落的星辰之剑踏上旅途，一路上结伴的伙伴各自背负着宿命。",
    meta: "全 24 集",
    tag: "新番更新至 20 集",
    hot: true,
  },
  {
    id: 15,
    title: "云上小镇",
    category: "动漫",
    genre: "治愈",
    year: 2024,
    region: "中国",
    rating: 8.6,
    poster:
      "https://readdy.ai/api/search-image?query=Whimsical%20small%20town%20floating%20above%20soft%20clouds%20at%20golden%20hour%2C%20cozy%20warm%20palette%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-15&orientation=portrait",
    summary: "云朵之上的小镇住着一群会发光的居民，他们的日常温柔而治愈。",
    meta: "全 12 集",
    tag: "治愈番剧",
  },
  {
    id: 16,
    title: "星厨争霸",
    category: "综艺",
    genre: "美食",
    year: 2025,
    region: "中国",
    rating: 8.0,
    poster:
      "https://readdy.ai/api/search-image?query=Chef%20plating%20a%20gourmet%20dish%20amid%20warm%20kitchen%20lights%20and%20flying%20sparks%2C%20energetic%20warm%20tones%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-16&orientation=portrait",
    summary: "二十四位新锐厨师同台竞技，在限时挑战中争夺年度星厨称号。",
    meta: "更新至 8 期",
    tag: "每周五更新",
  },
  {
    id: 17,
    title: "声动人心",
    category: "综艺",
    genre: "音乐",
    year: 2025,
    region: "中国",
    rating: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=Singer%20silhouette%20on%20a%20grand%20stage%20under%20a%20single%20warm%20spotlight%2C%20emotional%20mood%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-17&orientation=portrait",
    summary: "素人歌手与专业音乐人组队，用一场场现场演出讲述歌声背后的故事。",
    meta: "更新至 6 期",
    tag: "现场音乐",
  },
  {
    id: 18,
    title: "出发吧旅人",
    category: "综艺",
    genre: "旅行",
    year: 2024,
    region: "中国",
    rating: 7.9,
    poster:
      "https://readdy.ai/api/search-image?query=Backpacker%20on%20a%20scenic%20mountain%20road%20at%20sunrise%20holding%20a%20map%2C%20adventurous%20warm%20tones%2C%20cinematic%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20dark%20background%2C%20high%20detail%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=starcinema-poster-18&orientation=portrait",
    summary: "四位旅人轻装出发，用最朴素的方式走遍山川湖海，遇见不同的生活方式。",
    meta: "全 10 期",
    tag: "旅行纪实",
  },
];

export const featuredItems = [catalogItems[0], catalogItems[4], catalogItems[8], catalogItems[13], catalogItems[12]];

export const trendingSeries = [catalogItems[8], catalogItems[9], catalogItems[12], catalogItems[13], catalogItems[10], catalogItems[11]];

export const topRatedItems = [
  catalogItems[13],
  catalogItems[8],
  catalogItems[12],
  catalogItems[4],
  catalogItems[5],
  catalogItems[1],
  catalogItems[10],
  catalogItems[7],
  catalogItems[11],
  catalogItems[2],
];

export const updateFeed = [
  "《长夜长歌》更新至第 40 集 · 全集完结",
  "《剑与星尘》更新至第 20 集 · 新番热播",
  "《破晓行动》更新至第 18 集 · 悬疑高能",
  "《星厨争霸》更新至第 8 期 · 每周五上线",
  "《深海禁区》上线高清 4K 版本",
  "《边界线》全 28 集可在线观看",
  "《声动人心》更新至第 6 期 · 现场直击",
  "《城市之光》正在热映 · 犯罪片单收录",
];